.page {
    width: 100%;
}

@media (min-width: 75em) {
    .page {
        max-width: none;
    }
}
